import React from "react";
import styled from "styled-components";
import { Image, Theme, media } from "@literati/public-ui-shared-react";
import { ImageProps } from "@literati/public-ui-shared-react";

import Rainbow from "@/atoms/Icon/rainbow";

import { CheckoutSession } from "lib/api/checkout";
import { SubscriptionPlanCamelCase } from "lib/api/subscription";

import StepLayout from "components/Step/StepLayout";
import { Plans } from "components/PlanSelection/planSelectionTypes";

const Container = styled.div`
  margin: 1rem 0 0;

  ${media.md} {
    margin: 2rem 0 0;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #596eca;
  max-width: 375px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  margin: 0 0.5rem;
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.25rem;
`;

const StyledH2 = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 160%;
`;

const StruckPrice = styled.span`
  text-decoration: line-through;
  color: #8da8fc;
  font-size: 1rem;
`;

const NewPrice = styled.span`
  color: #546ac9;
  font-size: 1.25rem;
  font-weight: 700;
  padding: 0 0 0 0.125rem;
`;

const Disclaimer = styled.p`
  font-size: 0.875rem;
  font-weight: 900;
  color: #ea512f;
`;

const PerMonth = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10.5rem;
  padding: 1rem 1.25rem;
  background: #eff2ff;
  border-radius: 0 0 12px 12px;
`;

const StyledDiv = styled.div`
  display: flex;
  gap: 0.5rem;
  white-space: pre-line;
  font-size: 0.875rem;
`;

const ImageContainer = styled.div`
  height: 20px;
  width: 20px;
`;

const StyledP = styled.p`
  font-size: 0.875rem;
`;

export interface StepFall25PromoProps {
  checkoutSession?: CheckoutSession | null;
  onBackButtonClick?: () => void;
  onNextButtonClick?: () => void;
  plans?: Plans | null;
  selectPlanImageProps?: ImageProps | null;
  selectedPlan?: SubscriptionPlanCamelCase | null;
}

export const StepFall25Promo = ({
  onBackButtonClick,
  onNextButtonClick,
}: StepFall25PromoProps) => {
  return (
    <Theme>
      <StepLayout
        asForm={false}
        bgColor="white"
        disableContentSpacing
        heading="We have a surprise for you!"
        stepFooterProps={{
          backButtonProps: { onClick: onBackButtonClick },
          nextButtonProps: { onClick: onNextButtonClick },
        }}
        stepHeaderProps={{ backButtonProps: { onClick: onBackButtonClick } }}
      >
        <Container>
          <Card>
            <PriceContainer>
              <Image
                src="https://siren-images.literati.com/images/book_box_fall_25.original.png"
                alt="Fall 2025 Promo"
                contain
                height={79}
                width={173}
              />
              <StyledH2>
                Try 3 months of Book Clubs for{" "}
                <StruckPrice>$11.95 </StruckPrice>
                <NewPrice>$4.95</NewPrice>
                <PerMonth> per month</PerMonth>
              </StyledH2>
              <Disclaimer>
                Hurry: only available before the fair ends!
              </Disclaimer>
            </PriceContainer>
            <InfoContainer>
              <StyledDiv>
                <ImageContainer>
                  <Rainbow
                    styles={{ fill: "#596ECA" }}
                    height={20}
                    width={20}
                  />
                </ImageContainer>
                <StyledP>
                  {
                    "Cancel or change anytime.\nBecomes $11.95/box after promo period.\nBooks you decide to keep charged separately."
                  }
                </StyledP>
              </StyledDiv>
            </InfoContainer>
          </Card>
        </Container>
      </StepLayout>
    </Theme>
  );
};

export default StepFall25Promo;
